module.exports = __webpack_public_path__ + "img/localization-map.34ca173f.svg";